export const ADDON_ID = 'storybook/svelte-csf';